
import Vue from 'vue'
import { Alert } from '@/components'

export default Vue.extend({
   name: 'ErrorMessages',
   computed: {
      visible(): boolean {
         const showErrors = this.$store.state.showErrors
         const hasInternalErrors = this.$store.getters.validationMessages.length > 0
         const hasExternalErrors = this.$store.state.verificationErrors.length > 0
         return this.messages.length > 0 && ((showErrors && hasInternalErrors) || hasExternalErrors)
      },
      title(): string {
         if (this.$store.state.verificationErrorMessage.length > 0) {
            return this.$store.state.verificationErrorMessage
         }
         return 'Please correct the following errors and try again'
      },
      messages(): string[] {
         const currentStep = this.$store.state.step
         const viewedSteps = this.$store.state.viewedSteps
         const allMessages = this.$store.getters.validationMessages
         const relevantMessages = allMessages.filter(
            (msg: { Step: string }) => viewedSteps.includes(msg.Step) || msg.Step === currentStep
         )
         const messages: string[] = [
            ...relevantMessages.map((msg: { Text: string }) => msg.Text),
            ...this.$store.state.verificationErrors,
         ]
         return messages
      },
   },
   methods: {},
   components: {
      Alert,
   },
})
